function handleUpdateLoginUI() {
  const recoverTitle = document.querySelector('#recover');
  const loginText = document.querySelector('.login__text');
  const textMessage = document.createElement("div");
  const loginContent = document.querySelector('#customerLoginContent');

  loginText.innerHTML = 'Vi tar säkerheten för våra kundkonton på största allvar. Med ett starkt lösenord hjälper du till att skydda ditt konto, och vi ber dig därför att ange ett nytt lösenord. Du kommer att få ett mail med information om hur du går till väga. Tack på förhand!';
  recoverTitle.innerHTML = 'Du kommer att få ett mail med information om hur du skapar ett nytt lösenord';

  if (!loginContent.classList.contains('invited-user')) {
    loginContent.classList.add('invited-user');
  }
  
  document.querySelector('.recover__button').style.display = 'none';
}

async function handleSubmitRecoverForm(e) {
  e.preventDefault();
  e.stopPropagation();

  const emailInput = document.querySelector('#RecoverEmail');
  const reocoverForm = document.querySelector('#recover_customer_password');

  const response = await fetch('https://fr2q7z3612.execute-api.eu-central-1.amazonaws.com/prod/customers/validate', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email: emailInput.value })
  });
  const data = await response.json();

  if (!data || !data.customer || !data.customer.id) {
    return reocoverForm.submit();
  }

  const customerTags = data.customer.tags.split(',');
  const customerIsImported = customerTags.some((tag) => tag.trim() === 'imported');

  if ((data.customer.state === 'disabled' || data.customer.state === 'invited') && customerIsImported) {
    return handleUpdateLoginUI();
  }

  reocoverForm.submit();
}

const recoverBtn = document.querySelector("#recover-btn");
recoverBtn.onclick = handleSubmitRecoverForm;